import { Box, styled } from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: 20,
})
